import React, {useState, useEffect, useRef, useMemo} from "react";

import TableCell, {tableCellClasses} from "@mui/material/TableCell";

import TableRow from "@mui/material/TableRow";
import {styled} from "@mui/material/styles";
import {getUserAccessPermission, updateWatchlist} from "../../../../apihelper/profile";
import Box from "@mui/material/Box";
import json2mq from "json2mq";

import useMediaQuery from "@mui/material/useMediaQuery";
import {useNavigate} from "react-router-dom";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {BottomNavigation} from "@mui/material";
import SidebarMenuList from "../../../../includes/sidebarMenuList";
import {addToPortfolio, copyToPortfolio} from "../../../../apihelper/portfolio";
import {getCryporCurrencyListHome} from "../../../../apihelper/homepage";
import {getTotalunit, getFetchdropdown} from "../../../../apihelper/cryptocurrencylist";
import {Link, useLocation} from "react-router-dom";
import {RECOMMENDATION} from "../../../../common/constant/SubscriptionFeatures";
import {RECOMMENDATION_MESSAGE} from "../../../../common/constant/SubscriptionMessage";

// Define the keyframes for the left-right motion animation
const leftRightMotion = `
  @keyframes leftRightMotion {
    0% {
      transform: translateX(-30px); /* Start 30px left of center */
    }
    50% {
      transform: translateX(30px);  /* Move 30px right of center */
    }
    100% {
      transform: translateX(-30px); /* Return to 30px left of center */
    }
  }
`;

const drawerWidth = 292;

const useStyles = styled((theme) => ({
    tableContainer: {
        maxWidth: 900,
        margin: "0 auto",
    },
    table: {
        display: "none", // Hide the table on all screens
        [theme.breakpoints.down("sm")]: {
            display: "table", // Show the table on small screens only (mobile view)
        },
    },
}));

const Recommendation = (props) => {
    const {window1} = props;
    const [dropdownVisible, setDropdownVisible] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("fd_asc");
    const [sortDropdownVisible, setSortDropdownVisible] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [loader, setLoader] = useState(false);
    const [Usablewallet, setUsablewallet] = useState("");
    const [totalUnits, setTotalUnits] = useState(0);
    const [options, setOptions] = useState([]);
    const [predictionLoader, setPredictionLoader] = useState(false);
    const [newOptionValue, setNewOptionValue] = useState("");

    const [rowsToShow, setRowsToShow] = useState(7);
    const [selectedSort, setSelectedSort] = useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dataslug, setdataslug] = useState("");
    const sortRef = useRef();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [portfolioData, setPortfolioData] = useState([]);
    const location = useLocation();
    const loc = location.pathname;
    const [watchlistdata, setWatchlistdata] = useState([]);
    const [unit, setUnit] = useState("");
    const [buySell, setbuySell] = React.useState("");
    const [price, setPrice] = useState("");
    const [selectedDate, handleDateChange] = useState("");
    const [portfolioTypeId, setPortfolioTypeId] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [goToSubscribeAlertOpen, setGoToSubscribeAlertOpen] = useState(false);
    const [subscriptionText, setSubscriptionText] = useState("");
    const [isEligible, setIsEligible] = useState(true);
    const [userPermission, setUserPermission] = useState(null);
    const [userViews, setUserViews] = useState(0);
    const [userViewsFetched, setUserViewsFetched] = useState(false);

    const {selectedPortfolio, selectedPortfolioId, selectedTotalPortfolioValue} = props;

    const [portfolioId, setportfolioid] = useState("");
    const [portfolioName, setPortfolioName] = useState(selectedPortfolio);

    // const handleTotalViews = async () => {
    //     try {
    //         const userInfo = {
    //             user_id: userData.user_id,
    //             token: userData.token,
    //             column: "recommendations",
    //         };
    //         const response = await getUserTotalView(userInfo);
    //         setUserViews(response.permission);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };
    const handleUserPermission = React.useCallback(async () => {
        try {
            const feature = RECOMMENDATION();
            const data = {
                user_id: userData.user_id,
                token: userData.token,
                feature: feature,
            };
            const response = await getUserAccessPermission(data);
            setUserPermission(response?.permission);
        } catch (error) {
            console.error(error);
        }
    }, []);

    // useEffect(() => {
    //     if (userData?.user_id) {
    //         handleTotalViews();
    //         handleUserPermission();
    //     }
    // }, []);

    const fetchCryptoData = async () => {
    if (!portfolioName) {
        return;
    }

    try {
        const formData = new URLSearchParams();
        formData.append("portfolioName", portfolioName);
        formData.append("sortType", sortType);
        // formData.append("user_id", userData.user_id); // Uncomment if needed later

        const response = await fetch(
            "https://crowdwisdom.live/wp-json/api/v1/showCryptoRecommendationsFutureData1",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded", // ✅ simple header
                },
                body: formData.toString(), // ✅ avoids preflight
            }
        );

        const result = await response.json();

        if (result.code === "200" || result.code === "500") {
            // const processedData = getProcessesData(result.response);
            setData(result.response);
            console.log("result.response", result.response);
            // console.log("processed data", processedData);
            const cleanSymbols = result.response.map((item) => {
            const full = item.crypto_symbol || "";
            const parts = full.split("-");
            return parts[parts.length - 1]; // the actual crypto symbol (e.g., "BTC", "SUI")
            });

            const storageKey = `cw_recommendation_symbols_${portfolioId}`;
            localStorage.setItem(storageKey, JSON.stringify(cleanSymbols));


            if (result.response.length > 0) {
                const firstSymbol = result.response[0].crypto_symbol;
                const performanceCategory = firstSymbol.split("-")[2];
                setPerformanceType(performanceCategory);
            }

            if (Array.isArray(result.response) && result.response.length === 0) {
                setPredictionLoader(true);
            }

            setUserViewsFetched(true);
            // handleTotalViews(); // Keep commented if not needed
        } else if (result.code === "403") {
            setError(result.message);
        } else {
            setError(result.message);
        }
    } catch (err) {
        setError("An error occurred while fetching data.");
    } finally {
        setLoading(false);
    }
};


    // const getProcessesData = (data) => {
    //     if (!Array.isArray(data)) {
    //         return [];
    //     }

    //     const uniqueData = data.reduce((acc, current) => {
    //         const existingIndex = acc.findIndex((item) => item.crypto_name === current.crypto_name);
    //         if (existingIndex === -1) {
    //             acc.push(current);
    //         }
    //         return acc;
    //     }, []);

    //     return uniqueData;
    // }

    useEffect(() => {
        console.log("portfolioName", portfolioName);
        if (portfolioName) {
            fetchCryptoData();
        }
    }, [portfolioName]);

    const formatToNonZero = (number) => {
        number = parseFloat(number);

        if (number >= 1) {
            return number.toFixed(2);
        } else if (number >= 0.1) {
            return number.toFixed(1);
        } else if (number >= 0.01) {
            return number.toFixed(4);
        } else if (number >= 0.001) {
            return number.toFixed(5);
        } else if (number >= 0.0001) {
            return number.toFixed(6);
        } else if (number >= 0.00001) {
            return number.toFixed(7);
        } else if (number >= 0.000001) {
            return number.toFixed(8);
        } else if (number >= 0.0000001) {
            return number.toFixed(9);
        } else if (number >= 0.00000001) {
            return number.toFixed(10);
        } else if (number >= 0.000000001) {
            return number.toFixed(11);
        }
        return number.toFixed(1);
    };
    const [user_role, setuser_role] = useState("");
    const handleChange2 = (e) => {
        const value = e.target.value;
        // Check if the input contains a hyphen
        if (value.includes("-")) {
            setShowAlert(true); // Show the alert if there's a hyphen
        } else {
            setShowAlert(false); // Hide the alert if there's no hyphen
            setNewOptionValue(value); // Update the state with the new value
        }
    };

    const handleDialogSubmit = () => {
        // Update options state with the new option
        const newOption = {value: newOptionValue, label: newOptionValue};
        setOptions([...options, newOption]);
        setSelectedOption(newOption);
        // Close the dialog
        setIsDialogOpen(false);

        // setSelectedOption(selectedOption);
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getTotalunit({
            user_id: userData.user_id,
            slug: dataslug, // Assuming value contains the slug
            portfolio_type_id: newOption.value, // Adjust as needed
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setTotalUnits(res.total_uint);
                setNewOptionValue("");
                setUsablewallet(res.wallet_amount);
            } else {
                console.error("Data fething error");
            }
        });
    };

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const mediaQueryVar1 = useMediaQuery(
        json2mq({
            minWidth: 400,
        })
    );
    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxWidth: 420,
        })
    );

    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            border: 0,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            border: 0,
        },
    }));

    const isSmallScreen = useMediaQuery(
        json2mq({
            maxWidth: 380,
        })
    );

    const handleChange = async (selectedOption, slug) => {
        if (selectedOption && selectedOption._isNew_) {
            setIsDialogOpen(true);
            setSelectedOption(null);
            setdataslug(slug);
        } else if (!selectedOption) {
            // Handle the case when the selection is cleared
            setSelectedOption(null);
            setShowAlert(false);
            // Perform any other necessary actions
            return;
        } else {
            const selectedValue = selectedOption.value;
            if (selectedValue.includes("-")) {
                setErrorMessage("Hyphens are not allowed in the option."); // Set error message
                setShowAlert(true); // Show the alert
                return; // Abort further processing
            }
            setShowAlert(false);
            setSelectedOption(selectedOption);
            const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
            getTotalunit({
                user_id: userData.user_id,
                slug: slug, // Assuming value contains the slug
                portfolio_type_id: selectedOption.value, // Adjust as needed
                Token: userData.token,
            }).then((res) => {
                if (res.code === "200") {
                    setTotalUnits(res.total_uint);
                    setUsablewallet(res.wallet_amount);
                } else {
                    console.error("Data fething error");
                }
            });
        }
    };

    const handleCreate = async (inputValue) => {
        setTotalUnits(0);
        setUsablewallet("");

        if (options.find((option) => option.value === inputValue)) {
            return; // Exit early if the option already exists
        }
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const newOption = {value: inputValue, label: inputValue};
        const newOptions = [...options, newOption]; // Create a new array with the existing options plus the new one
        setOptions(newOptions); // Update the options state
        const createdOption = newOptions.find((option) => option.value == inputValue);
        if (createdOption) {
            handleChange(createdOption);
        }
    };

    const handleLoginClick = () => {
        if (!userData) {
            window.history.pushState({}, "", "/login");
            localStorage.setItem("isPopupManuallyOpened", "true");
        } else if (!isEligible) {
            setGoToSubscribeAlertOpen(true);
            setSubscriptionText(RECOMMENDATION_MESSAGE());
        }
    };

    const handleModalClose = () => {
        navigate(location.pathname, {replace: true});
    };

    const StyledTableRow = styled(TableRow)(({theme}) => ({
        // hide last border

        "& td, & th": {
            border: 0,
        },
    }));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );
    const [slugpopupdata, setSlugpopupdata] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });
    const [slugdata, setSlugdata] = useState([]);
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [selectedOption, setSelectedOption] = useState([]);
    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbaropen(false);
    };
    const [severity, setSeverity] = useState("info");
    const [slugName, setSlugName] = useState("");

    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const handleClick = (buySell) => {
        setSnackbaropen(true);
        setOpen(true);
        setSeverity("info");
        setIsFormSubmitted(false);
        setMsgforUpdatePortfolio("loading...");
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const portfolioId =
            selectedOption && !isNaN(parseInt(selectedOption.value)) ? parseInt(selectedOption.value) : 0;
        const existingPortfolio = portfolioId > 0 ? "yes" : "no"; // Determine existing_portfolio based on portfolioId

        addToPortfolio({
            portfolio_type_id: portfolioId,
            portfolio_name: selectedOption ? selectedOption.label : "", // Ensure selectedOption is defined

            existing_portfolio: existingPortfolio,
            user_id: userData.user_id,
            slug: slugpopupdata.slugname,
            unit: unit,
            acquisition_price: price,
            date_time: selectedDate,
            type: buySell,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setSeverity("info");
                setMsgforUpdatePortfolio(res.message);
                setPortfolioTypeId(res.portfolio_type_id);
                setIsFormSubmitted(true);
            } else {
                setSeverity("error");
                // setOpen(true)
                setMsgforUpdatePortfolio(res.message);
            }
        });
    };

    const container = window1 !== undefined ? () => window1().document.body : undefined;

    const [isTableView, setIsTableView] = useState(true);
    const [selectedButton, setSelectedButton] = useState("CoinPrices");
    const [starredPortfolios, setStarredPortfolios] = useState({});
    const [performanceType, setPerformanceType] = useState("");

    React.useEffect(() => {
        setPortfolioName(selectedPortfolio);
    }, [selectedPortfolio]);

    React.useEffect(() => {
        setportfolioid(selectedPortfolioId);
    }, [selectedPortfolioId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setSortDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = (index) => {
        setDropdownVisible(dropdownVisible === index ? null : index);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSortChange = (sortType) => {
        setSortType(sortType);
        setSortDropdownVisible(false);
        setSelectedSort(sortType);
    };

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

    const filteredData = data;

    const handleLoadMore = () => {
        setRowsToShow(rowsToShow + 7);
    };

    const compareValues = (val1, val2, order = "asc") => {
        if (val1 === "Pending") return 1; // Ensure 'Pending' is always last
        if (val2 === "Pending") return -1; // Ensure 'Pending' is always last
        if (order === "asc") return val1 > val2 ? 1 : val1 < val2 ? -1 : 0;
        return val1 < val2 ? 1 : val1 > val2 ? -1 : 0;
    };

    const sortedData = [...filteredData].sort((a, b) => {
        switch (sortType) {
            case "ac_asc":
                return compareValues(a.accuracy, b.accuracy, "asc");
            case "ac_desc":
                return compareValues(a.accuracy, b.accuracy, "desc");
            default:
                return 0;
        }
    });

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (portfolioData && portfolioData.length > 0) {
            setIsDataLoaded(true); // Set to true when data is available
        }
    }, [portfolioData]);

    const [isPredictionDataLoaded, setIsPredictionDataLoaded] = useState(false);

    const currentUrl = window.location.pathname; // Get the current URL path

    let url;

    if (currentUrl.includes("/my-portfolio/")) {
        url = `/my-portfolio/${portfolioId}/${portfolioName}/detailed-portfolio-analysis`;
    } else if (currentUrl.includes("/portfolio/")) {
        url = `/portfolio/${portfolioName}/detailed-portfolio-analysis`;
    }

    // Check if all rows are ignored
    const handleStarClick = (portfolio_id) => {
        console.log("portf_id", portfolio_id);

        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const user_id = userData.user_id;
        const token = userData.token;

        // Toggle the starred state for this portfolio
        setStarredPortfolios((prevState) => {
            const isStarred = prevState[portfolio_id];

            // If currently starred, remove from local storage and watchlist
            const updatedState = {
                ...prevState,
                [portfolio_id]: !isStarred, // Toggle star state for this portfolio ID
            };

            // Save the updated starred portfolios to local storage
            localStorage.setItem("starred_portfolios", JSON.stringify(updatedState));

            // Update the watchlist in the backend
            updateWatchlist({
                user_id,
                portfolio_id,
                token,
                action: isStarred ? "remove" : "add",
            }).then((res) => {
                if (res.code === "200") {
                    setWatchlistdata(res.data);
                } else {
                    console.error("Data Fetching Error");
                }
            });

            return updatedState;
        });
    };

    // Load saved starred portfolios from local storage when the component mounts
    useEffect(() => {
        const savedStarredPortfolios = JSON.parse(localStorage.getItem("starred_portfolios"));
        if (savedStarredPortfolios) {
            setStarredPortfolios(savedStarredPortfolios);
        }
    }, []);

   

    const {filter} = props; // Destructure filter from props
    const {onButtonClick} = props;
    const [selectedmenu, setselectedmenu] = useState("");
    const [value, setValue] = React.useState(0);

    const [alignment, setAlignment] = React.useState("left");
    const [showloginpage, setShowloginpage] = useState(false);
    const [index, setIndex] = useState(0);
    const [addMoreLoader, setAddMoreLoader] = useState(false);

    const [loaderbutton, setLoaderButton] = useState(true);
    const [loadingForLogin, setLoadingForLogin] = useState(false);
    const [lastUpdatedTime, setLastUpdatedTiem] = useState("--");
    const [loaderForSymbolLink, setLoaderForSymbolLink] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [hashtagData, setHashtagData] = useState("");
    const handleAlignment = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const mediaQueryVar5 = useMediaQuery(
        json2mq({
            minWidth: 1900,
        })
    );


    const open1 = Boolean(anchorEl);
    const [loading1, setLoading1] = useState(true);

    // Step 1: Create a shallow copy of slugdata
    const slugdata1 = slugdata.slice();

    // Step 2: Sort slugdata1 based on total_roi_value
    const sortedSlugdata = slugdata1;

    const filterData = [
        {categories: "Bollinger Bands", subOptions: ["Bullish", "Bearish"]},
        {categories: "Fibonacci Retracement", subOptions: ["Bullish", "Bearish"]},
    ];

    const [filterAnchor, setFilterAnchor] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState([]); // Store selected filters as objects

    const handleFilterOpen = (event) => setFilterAnchor(event.currentTarget);
    const handleFilterClose = () => setFilterAnchor(null);

    const isFilterOpen = Boolean(filterAnchor);

    const handleAddToPortfolio = (idx) => {
        getCryporCurrencyListHome({
            slug: idx,
        }).then((res) => {
            if (res.code === "200") {
                // Update slugdata
                setSlugdata(res.data);
                setuser_role(res.user_role);

                // Use res.data directly here
                const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
                if (userData) {
                    setSlugpopupdata({
                        slugname: res.data[0].slug,
                        slug: res.data[0].name,
                        units: res.data[0].total_unit,
                        pricetoday: res.data[0].price_today,
                        logo: res.data[0].logo,
                    });

                    setOpen(true);
                } else {
                    // Save the source in sessionStorage
                    const originalUrl = window.location.pathname + window.location.search;
                    sessionStorage.setItem("originalUrl", originalUrl);
                    sessionStorage.setItem("loginSource", "addToPortfolio");
                    window.history.pushState({}, "", "/login");
                    localStorage.setItem("isPopupManuallyOpened", "true");
                }
            } else {
                console.error("Data fetching error");
            }
        });
    };
    const sortedData1 = data;
const [displayData, setDisplayData] = useState([]); // Displayed cryptos
const [queueData, setQueueData] = useState([]);     // Cryptos queued for later

// Organize batches based on numeric prefixes in crypto symbols
const organizeBatches = (data) => {
    const batches = {};

    data.forEach((crypto) => {
        const prefix = crypto.crypto_symbol.match(/^\d+/)?.[0];
        if (prefix) {
            if (!batches[prefix]) {
                batches[prefix] = [];
            }
            batches[prefix].push(crypto);
        }
    });

    return batches;
};

// Round-robin display logic for batches
const roundRobinDisplay = (data) => {
    const batches = organizeBatches(data);
    let displayOrder = [];
    let batchQueue = [];

    Object.keys(batches).forEach((batchPrefix) => {
        const batch = batches[batchPrefix];
        displayOrder.push(...batch.slice(0, 2)); // First 2 cryptos per batch
        batchQueue.push(...batch.slice(2));      // Remaining cryptos
    });

    return { displayOrder, batchQueue };
};

// Effect to recalculate display data when sortedData1 changes
useEffect(() => {
    if (sortedData1 && sortedData1.length > 0) {
        const { displayOrder, batchQueue } = roundRobinDisplay(sortedData1);
        console.log("displayOrder", displayOrder);
        setDisplayData(displayOrder);
        setQueueData(batchQueue);
        setIsPredictionDataLoaded(true);
    } else {
        setIsPredictionDataLoaded(false);
    }
}, [sortedData1]);

const [unreadAlerts, setUnreadAlerts] = useState(0);

    return (
        <div className="crypto-recommendation">

            <div>
                {mediaQueryVar ? (
                    <div className="layout" style={{margin:0, padding:0}}>
                        <div className="content" style={{margin:0, padding:0}}>
                           
                            {isPredictionDataLoaded === false && predictionLoader ? (
                                <div
                                    style={{
                                        border: "",
                                        margin: "0px 2%",
                                        marginTop: "4%",
                                        textAlign: "center",
                                        color: "black",
                                        fontSize: "18px",
                                        backgroundColor: "white",
                                        padding: "2% ",
                                        borderRadius: "8px",
                                    }}
                                >
                                    No Crypto Recommendations at the moment.
                                </div>
                            ) : (
                                <div>
                                    <div
                                        style={{
                                            border:  "",
                                            fontFamily: "Satoshi, sans-serif",
                                            backgroundColor: isPredictionDataLoaded ? "white" : "",
                                            padding: "0%",
                                            borderRadius: "8px",
                                            margin: isPredictionDataLoaded ? "2%" : "0%",
                                            marginRight: isPredictionDataLoaded ? "4%" : "0%",
                                            margin:0
                                        }}
                                    >
                                        <table
                                            style={{width: "100%", borderCollapse: "separate", borderSpacing: "0 20px"}}
                                        >
                                            <tbody>
                                                {isPredictionDataLoaded === false ? (
                                                    <tr colspan="5">
                                                        <td>
                                                            <div
                                                                style={{
                                                                    position: "relative",
                                                                    border: "",
                                                                    margin: "0% 2% 0% 0%",
                                                                    padding: "2%",
                                                                    borderRadius: "8px",
                                                                    textAlign: "center",
                                                                    height: "30vh",
                                                                    overflow: "hidden", // Ensures content stays within the div
                                                                }}
                                                            >
                                                                {/* Blurred background image */}
                                                                <div
                                                                    style={{
                                                                        backgroundImage: `url(${window.constants.asset_path}/images/default-recommed.png)`,
                                                                        backgroundSize: "cover",
                                                                        backgroundPosition: "center center",
                                                                        filter: "blur(5px)",
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: 0,
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        zIndex: 0,
                                                                    }}
                                                                ></div>

                                                                {/* Overlay content without blur */}
                                                                <div
                                                                    style={{
                                                                        position: "relative",
                                                                        zIndex: 1,
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        height: "100%",
                                                                    }}
                                                                >
                                                                    <style>{leftRightMotion}</style>
                                                                    <div
                                                                        style={{
                                                                            position: "relative",
                                                                            width: "64px",
                                                                            height: "64px",
                                                                        }}
                                                                    >
                                                                        {/* Lens image with left-right motion animation */}

                                                                            <img
                                                                                src={
                                                                                    window.constants.asset_path +
                                                                                    "/images/lens.png"
                                                                                }
                                                                                alt="Searching Lens"
                                                                                style={{
                                                                                    width: "64px",
                                                                                    height: "64px",
                                                                                    position: "absolute",
                                                                                    animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                                                                }}
                                                                            />
                                                                    </div>
                                                                    <p
                                                                        style={{
                                                                            fontFamily: "Satoshi,sans-serif",
                                                                            marginTop: "10px",
                                                                            fontSize: "18px",
                                                                            color: "black",
                                                                        }}
                                                                    >
                                                                        <b>
                                                                            {!userData
                                                                                ? "Sign Up now to Access Best Crypto Recommendations"
                                                                                : !isEligible
                                                                                ? RECOMMENDATION_MESSAGE()
                                                                                : "Searching For The Best Crypto, Personalized"}
                                                                        </b>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    data.map((data, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr
  style={{
    filter: "none",
    background:
      "linear-gradient(180deg, rgba(137, 184, 245, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
  }}
>
  {(() => {
    const splitSymbol = data.crypto_symbol?.split("-");
    const displaySymbol = splitSymbol?.[3] || data.crypto_symbol;
    const firstPartSymbol = splitSymbol?.[1] || "";

    const symbolBoxStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      background:
        "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
      borderRadius: "20px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      padding: "10px",
      height: "62px",
      width: "100%",
    };

    const logoStyle = {
      borderRadius: "50%",
      border: "2px solid #000",
      width: "36px",
      height: "36px",
      marginRight: "10px",
    };

    return (
      <>
        {/* 1. First Symbol (NEIRO) */}
        <td
          style={{
            width: "20%",
            padding: "10px",
            border: "1px solid rgba(24, 119, 242, 1)",
            borderRight:"none",
            borderRadius: "10px 0 0 10px",
            verticalAlign: "middle",
          }}
        >
          <div style={symbolBoxStyle}>
            <img
              alt={firstPartSymbol}
              src={data.target_logo}
              style={logoStyle}
            />
            <a
              
              style={{
                color: "black",
                textDecoration: "none",
                fontWeight: "700",
                fontSize: "20px",
                marginLeft: "10px",
              }}
            >
            <span style={{ fontWeight: "700", fontSize: "20px" }}>{firstPartSymbol}</span>
            </a>
          </div>
        </td>

        {/* 2. Recommended Symbol (CHILLGUY) */}
        <td
          style={{
            width: "20%",
            padding: "10px",
            border: "1px solid rgba(24, 119, 242, 1)",
            borderLeft:"none",
            borderRight:"none",
            verticalAlign: "middle",
          }}
        >
          <div style={symbolBoxStyle}>
            <img
              alt={displaySymbol}
              src={data.symbol_logo}
              style={logoStyle}
            />
            <a
              
              style={{
                color: "black",
                textDecoration: "none",
                fontWeight: "700",
                fontSize: "20px",
                marginLeft: "10px",
              }}
            >
              {displaySymbol}
            </a>
          </div>
        </td>

        {/* 3. Explanation */}
        <td
  style={{
    width: "40%",
    padding: "10px",
    border: "1px solid rgba(24, 119, 242, 1)",
    borderRight: "none",
    borderLeft: "none",
    verticalAlign: "middle",
    textAlign: "left",
  }}
>
  <div style={{ margin: "0 auto", maxWidth: "90%" }}>
    <p style={{ margin: "0 0 8px", textAlign: "left" }}>
      We recommend <b>{displaySymbol}</b> as replacement.
    </p>
    <ul style={{ paddingLeft: "18px", margin: "0", listStylePosition: "inside" }}>
      <li style={{ marginBottom: "4px" }}>
        <b>{displaySymbol}</b> is an {data.recommend_crypto_grade}
      </li>
      <li style={{ marginBottom: "4px" }}>
        Influencers are currently {data.influencer_status}
      </li>
      <li>
        Machine Learning Signal Indicates a {data.recommend_crypto_signal}
      </li>
    </ul>
  </div>
</td>


        {/* 4. CTA Button */}
        <td
          style={{
            width: "20%",
            padding: "10px",
            border: "1px solid rgba(24, 119, 242, 1)",
            borderLeft:"none",
            borderRadius: "0 10px 10px 0",
            verticalAlign: "middle",
          }}
        >
          <button
            onClick={() => navigate(`/crypto/${data.crypto_name}`)}
            style={{
              background:
                "linear-gradient(91.4deg, rgba(154, 255, 249, 0.6) 18.86%, rgba(255, 240, 109, 0.6) 100.02%)",
              padding: "8px 20px",
              borderRadius: "50px",
              border: "1px solid rgba(24, 119, 242, 1)",
              color: "rgba(24, 119, 242, 1)",
              fontWeight: "700",
              fontSize: "16px",
              cursor: "pointer",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              width: "fit-content",
              margin: "0 auto",
              display: "block",
            }}
          >
            Check Out Now
          </button>
        </td>
      </>
    );
  })()}
</tr>


                                                            </React.Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                            {/* <p className="p-4 fw-bold">
                                {!userData?.user_id ? (
                                    // User not logged in
                                    <>
                                        Sign up now for free access{" "}
                                        <a
                                            href="#"
                                            className="ms-2 text-primary"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                sessionStorage.setItem(
                                                    "originalUrl",
                                                    `/portfolio/${portfolioName.replace(/ /g, "-")}/recommendations`
                                                );
                                                handleLoginClick();
                                            }}
                                        >
                                            Sign Up
                                        </a>
                                    </>
                                ) : userPermission == null ||
                                  userViews == null ||
                                  userPermission === "" ||
                                  userViews === "" ? (
                                    // When user permission and views are still fetching or invalid
                                    "Loading..."
                                ) : (isNaN(userPermission) && userPermission === "unlimited") ||
                                  isNaN(userViews) ? null : Number(userPermission) - Number(userViews) === 0 ? ( // When userPermission is NaN (invalid data)
                                    // When user has no views left

                                    <>
                                        No free views left!
                                        {
                                            <a href="/subscriptions" className="ms-2 text-primary">
                                                Subscribe Now
                                            </a>
                                        }
                                    </>
                                ) : (
                                    // When user has some views left
                                    <>
                                        Only {Math.max(0, Number(userPermission) - Number(userViews))} free views left!
                                        ({userViews}/{userPermission} used)
                                        {Number(userViews) > 7 && (
                                            <a href="/subscriptions" className="ms-2 text-primary">
                                                Subscribe Now
                                            </a>
                                        )}
                                    </>
                                )}
                            </p> */}
                        </div>
                    </div>
                ) : (
                    <div style={{paddingBottom: "70px"}}>
                        {isPredictionDataLoaded === false && predictionLoader ? (
                            <div>
                                <div
                                    style={{
                                        border: "",
                                        margin: "0px 2%",
                                        marginTop: "4%",
                                        textAlign: "center",
                                        color: "black",
                                        fontSize: "18px",
                                        backgroundColor: "white",
                                        padding: "2% ",
                                        borderRadius: "8px",
                                    }}
                                >
                                    No Crypto Recommendations at the moment.
                                </div>
                            </div>
                        ) : (
                            <div>
                                {isPredictionDataLoaded === false && (
                                    // Show skeleton loaders while data is loading

                                    // Inside your component's JSX

                                    <div
                                        style={{
                                            position: "relative",
                                            border: "",
                                            margin: "3% 2% 2% 2%",
                                            padding: "2%",
                                            borderRadius: "8px",
                                            textAlign: "center",
                                            height: "30vh",
                                            overflow: "hidden", // Ensures content stays within the div
                                        }}
                                    >
                                        {/* Blurred background image */}
                                        <div
                                            style={{
                                                backgroundImage: `url(${window.constants.asset_path}/images/default-recommend-2.png)`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center center",
                                                filter: "blur(5px)",
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                zIndex: 0,
                                            }}
                                        ></div>

                                        {/* Overlay content without blur */}
                                        <div
                                            style={{
                                                position: "relative",
                                                zIndex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "100%",
                                            }}
                                        >
                                            <style>{leftRightMotion}</style>
                                            <div style={{position: "relative", width: "64px", height: "64px"}}>
                                                {/* Lens image with left-right motion animation */}

                                               
                                                    <img
                                                        src={window.constants.asset_path + "/images/lens.png"}
                                                        alt="Searching Lens"
                                                        style={{
                                                            width: "64px",
                                                            height: "64px",
                                                            position: "absolute",
                                                            animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                                        }}
                                                    />
                                                
                                            </div>
                                            <p
                                                style={{
                                                    fontFamily: "Satoshi,sans-serif",
                                                    marginTop: "10px",
                                                    fontSize: "18px",
                                                    color: "black",
                                                }}
                                            >
                                                <b>
                                                Searching For The Best Crypto, Personalized
                                                </b>
                                            </p>
                                        </div>
                                    </div>
                                )}
                                {isPredictionDataLoaded==false ? (
                                    <div
                                        style={{
                                            border: "",
                                            margin: "0px 2%",
                                            marginTop: "4%",
                                            textAlign: "center",
                                            color: "black",
                                            fontSize: "18px",
                                            backgroundColor: "white",
                                            padding: "2% ",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        No more recommendations available today.
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            border:  "",
                                            fontFamily: "Satoshi, sans-serif",
                                            backgroundColor: "white",
                                            padding: "0%",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        {data.map((data, index) => (
                                            <div className="is-mobile">
                                                <div
                                                    className="sm-table-card"
                                                    style={{
                                                        background:
                                                            "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%);",
                                                    }}
                                                >
                                                    <div className="sm-table-heading">
  <div className="d-flex justify-content-between align-items-center">
    {/* Left side: Logo + Symbol */}
    <div className="d-flex align-items-center" style={{ marginLeft: "12px", gap: "6px" }}>
      <img
        alt="image"
        src={data.target_logo}
        className="analysis-icon"
        style={{
          width: 30,
          height: 30,
          borderRadius: 19,
        }}
      />
      <h6 style={{ margin: 0 }}>{data.crypto_symbol.split("-")[1]}</h6>
    </div>

    {/* Right side: Same Logo + Symbol */}
    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
      <img
        alt="image"
        src={data.symbol_logo}
        className="analysis-icon"
        style={{
          width: 30,
          height: 30,
          borderRadius: 19,
        }}
      />
      <h6 style={{ margin: 0 }}>{data.crypto_symbol.split("-")[3]}</h6>
    </div>
  </div>
</div>

                                                    <div className="sm-table-body d-flex flex-wrap">
                                                        <p>
                                                            we recommend{" "}
                                                            <a
                                                                href={`${process.env.REACT_APP_HOME_URL}crypto/${data.crypto_name}`}
                                                                style={{color: "black"}}
                                                            >
                                                                {data.crypto_symbol.split("-")[3]}
                                                            </a>{" "}
                                                            as replacement.
                                                            {/* Rules will be in 3 lines.{" "} */}
                                                            <ul>
                                                                <li>
                                                                    <a
                                                                        href={`${process.env.REACT_APP_HOME_URL}crypto/${data.crypto_name}`}
                                                                        style={{
                                                                            color: "black",
                                                                        }}
                                                                    >
                                                                        {data.crypto_symbol.split("-")[3]}
                                                                    </a>{" "}
                                                                    is an {data.recommend_crypto_grade}
                                                                </li>
                                                                <li>
                                                                    Influencers are currently {data.influencer_status}
                                                                </li>
                                                                <li>
                                                                    Machine Learning Signal Indicates a{" "}
                                                                    {data.recommend_crypto_signal}
                                                                </li>
                                                            </ul>
                                                        </p>
                                                    </div>

                                                    <div className="sm-table-footer d-flex justify-content-around">
                                                        <div className="position-relative d-inline-block">
                                                            <button
                                                                key={index}
                                                                className="sm-btn-1 position-relative d-flex align-items-center"
                                                                onClick={() => {
                                                                    navigate(`/crypto/${data.crypto_name}`);
                                                                }}
                                                                style={{
                                                                    color: "rgba(24, 119, 242, 1)",
                                                                }}
                                                            >
                                                                <span>Check Out Now</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {/* {displayData.map((data, index) => (
                                            <React.Fragment key={index}>
                                                <Box
                                                    sx={{
                                                        overflowY: "auto",
                                                        "&::-webkit-scrollbar": {display: "none"},
                                                        scrollbarWidth: "none",
                                                        marginBottom:
                                                            index === displayData.length - 1 ? "50px" : "12px",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            padding: "0",
                                                            background:
                                                                "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                                            borderRadius: "6px",
                                                            marginTop: "15px",
                                                            marginBottom: "10px",
                                                            border: "",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "grid",
                                                                gridTemplateColumns: "120px auto auto",
                                                                alignItems: "center",
                                                                padding: "8px 4px",
                                                                borderBottom: "2px solid #DFDFDF",
                                                            }}
                                                        >
                                                            {/* Column 1: Performance Type */}
                                        {/* <span
                                                                style={{
                                                                    fontSize: "12px",
                                                                    color: "black",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {performanceType}
                                                            </span> */}

                                        {/* Column 2: Crypto Details */}
                                        {/* <span
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                <img
                                                                    alt=""
                                                                    src={data.target_logo}
                                                                    style={{
                                                                        borderRadius: "19px",
                                                                        border: "2px solid #000",
                                                                        width: "36px",
                                                                        height: "36px",
                                                                        marginRight: "8px",
                                                                        filter: !userData ? "blur(5px)" : "none",
                                                                    }}
                                                                />
                                                                <Box style={{position: "relative"}}>
                                                                    <a
                                                                        href={`${process.env.REACT_APP_HOME_URL}crypto/${data.target_name}`}
                                                                        onClick={(e) => {
                                                                            if (!userData) {
                                                                                e.preventDefault(); // Prevent navigation
                                                                                const originalUrl = `${process.env.REACT_APP_HOME_URL}crypto/${data.target_name}`; // Use backticks for template literals
                                                                                sessionStorage.setItem(
                                                                                    "originalUrl",
                                                                                    originalUrl
                                                                                ); // Save the original URL to sessionStorage
                                                                                handleLoginClick(); // Trigger the login click handler
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            color: "black",
                                                                            marginLeft: "4px",
                                                                            whiteSpace: "nowrap",
                                                                            fontSize: "12px",
                                                                            filter: !userData ? "blur(5px)" : "none",
                                                                        }}
                                                                    >
                                                                        {data.crypto_symbol.split("-")[1]}
                                                                    </a>
                                                                    {!userData && (
                                                                        <img
                                                                            onClick={(e) => {
                                                                                if (!userData) {
                                                                                    e.preventDefault(); // Prevent navigation

                                                                                    const originalUrl = `${process.env.REACT_APP_HOME_URL}crypto/${data.target_name}`; // Use backticks for template literals
                                                                                    sessionStorage.setItem(
                                                                                        "originalUrl",
                                                                                        originalUrl
                                                                                    ); // Save the original URL to sessionStorage

                                                                                    handleLoginClick(); // Trigger the login click handler
                                                                                }
                                                                            }}
                                                                            src={
                                                                                window.constants.asset_path +
                                                                                "/images/lock.svg"
                                                                            }
                                                                            alt="Lock Icon"
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "50%",
                                                                                left: "50%",
                                                                                transform: "translate(-50%, -50%)",
                                                                                cursor: "pointer",
                                                                                width: "20px", // Adjust size as needed
                                                                                height: "20px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Box>
                                                            </span> */}

                                        {/* Column 3: Category */}
                                        {/* <span
                                                                style={{
                                                                    borderRadius: "15px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    color: "#000",
                                                                    border: "",
                                                                    padding: "2px 11px",
                                                                    textAlign: "center",
                                                                    backgroundColor:
                                                                        "linear-gradient(91.4deg, rgba(154, 255, 249, 0.6) 18.86%, rgba(255, 240, 109, 0.6) 100.02%)",
                                                                }}
                                                            >
                                                                {data.category}
                                                            </span>
                                                        </Box>
                                                        <Box sx={{background: "#fff"}}> */}
                                        {/* Recommendation Row */}
                                        {/* <Box
                                                                sx={{
                                                                    display: "grid",
                                                                    gridTemplateColumns: "120px auto 50px",
                                                                    alignItems: "center",
                                                                    padding: "8px 4px",
                                                                    borderBottom: "2px solid #DFDFDF",
                                                                }}
                                                            > */}
                                        {/* Column 1: Recommendation Label */}
                                        {/* <span
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        color: "#76787A",
                                                                        fontWeight: "500",
                                                                    }}
                                                                >
                                                                    Recommendation:
                                                                </span> */}

                                        {/* Column 2: Recommendation Details */}
                                        {/* <span style={{display: "flex", alignItems: "center"}}>
                                                                    <img
                                                                        alt=""
                                                                        src={data.symbol_logo}
                                                                        style={{
                                                                            borderRadius: "19px",
                                                                            border: "2px solid #000",
                                                                            width: "36px",
                                                                            height: "36px",
                                                                            marginRight: "8px",
                                                                        }}
                                                                    />
                                                                    <a
                                                                        href={`${process.env.REACT_APP_HOME_URL}crypto/${data.crypto_name}`}
                                                                        style={{
                                                                            color: "black",
                                                                            marginLeft: "4px",
                                                                            fontSize: "12px",
                                                                        }}
                                                                    >
                                                                        {data.crypto_symbol.split("-")[3]}
                                                                    </a>
                                                                </span> */}

                                        {/* Column 3: Action Buttons */}
                                        {/* <span
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                    }}
                                                                >
                                                                    <Button
                                                                        onClick={() =>
                                                                            handleAddToPortfolio(
                                                                                data.crypto_symbol.split("-")[3]
                                                                            )
                                                                        }
                                                                        style={{}}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display: "inline-flex",
                                                                                border: "1px solid #1877F2",
                                                                                borderRadius: "50%",
                                                                                padding: "3px 4px",
                                                                                marginLeft: "12vw",
                                                                            }}
                                                                        >
                                                                            <img
                                                                                width="12px"
                                                                                src={
                                                                                    window.constants.asset_path +
                                                                                    "/images/plus.svg"
                                                                                }
                                                                                alt="Add"
                                                                            />
                                                                        </div>
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => handleIgnoreClick(index)}
                                                                        style={{marginRight: "-5px"}}
                                                                    >
                                                                        <img
                                                                            width="20px"
                                                                            src={
                                                                                window.constants.asset_path +
                                                                                "/images/trash.svg"
                                                                            }
                                                                            alt="Ignore"
                                                                        />
                                                                    </Button>
                                                                </span>
                                                            </Box> */}

                                        {/* Price and Forecast Row */}
                                        {/* <Box
                                                                sx={{
                                                                    display: "grid",
                                                                    gridTemplateColumns: "1fr 1fr",
                                                                    alignItems: "center",
                                                                    padding: "8px 4px",
                                                                }}
                                                            > */}
                                        {/* Column 1: Today's Price */}
                                        {/* <span
                                                                    style={{
                                                                        fontSize: "13px",
                                                                        color: "#76787A",
                                                                        fontWeight: "500",
                                                                        marginLeft: "1%",
                                                                    }}
                                                                >
                                                                    Today's Price: {data.current_price}
                                                                </span> */}

                                        {/* Column 2: Forecast Price */}
                                        {/* <span
                                                                    style={{
                                                                        fontSize: "13px",
                                                                        color: "#76787A",
                                                                        fontWeight: "500",
                                                                        textAlign: "right",
                                                                        marginRight: "1%",
                                                                    }}
                                                                >
                                                                    Forecast 2025: {data.forecast_price}
                                                                </span>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </React.Fragment> */}
                                        {/* ))}  */}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* <p className="p-4 fw-bold">
                            {!userData?.user_id ? (
                                // User not logged in
                                <>
                                    Sign up now for free access{" "}
                                    <a
                                        href="#"
                                        className="ms-2 text-primary"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            sessionStorage.setItem(
                                                "originalUrl",
                                                `/portfolio/${portfolioName.replace(/ /g, "-")}/recommendations`
                                            );
                                            handleLoginClick();
                                        }}
                                    >
                                        Sign Up
                                    </a>
                                </>
                            ) : userPermission == null ||
                              userViews == null ||
                              userPermission === "" ||
                              userViews === "" ? (
                                // When user permission and views are still fetching or invalid
                                "Loading..."
                            ) : (isNaN(userPermission) && userPermission === "unlimited") ||
                              isNaN(userViews) ? null : Number(userPermission) - Number(userViews) === 0 ? ( // When userPermission is NaN (invalid data)
                                // When user has no views left

                                <>
                                    No free views left!
                                    {
                                        <a href="/subscriptions" className="ms-2 text-primary">
                                            Subscribe Now
                                        </a>
                                    }
                                </>
                            ) : (
                                // When user has some views left
                                <>
                                    Only {Math.max(0, Number(userPermission) - Number(userViews))} free views left! (
                                    {userViews}/{userPermission} used)
                                    {Number(userViews) > 7 && (
                                        <a href="/subscriptions" className="ms-2 text-primary">
                                            Subscribe Now
                                        </a>
                                    )}
                                </>
                            )}
                        </p> */}
                    </div>
                )}
                {/* <p className="p-4 fw-bold">
                                {!userData?.user_id ? (
                                    // User not logged in
                                    <>
                                        Sign up now for free access{" "}
                                        <a
                                            href="#"
                                            className="ms-2 text-primary"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                sessionStorage.setItem(
                                                    "originalUrl",
                                                    `/portfolio/${portfolioName.replace(/ /g, "-")}/recommendations`
                                                );
                                                handleLoginClick();
                                            }}
                                        >
                                            Sign Up
                                        </a>
                                    </>
                                ) : userPermission == null ||
                                  userViews == null ||
                                  userPermission === "" ||
                                  userViews === "" ? (
                                    // When user permission and views are still fetching or invalid
                                    "Loading..."
                                ) : isNaN(userPermission) && userPermission === "unlimited" ||
                                  isNaN(userViews) ? // When userPermission is NaN (invalid data)
                                null : Number(userPermission) - Number(userViews) === 0 ? (
                                    // When user has no views left
                                    
                                    <>
                                        No free views left!
                                        {(
                                            <a href="/subscriptions" className="ms-2 text-primary">
                                                Subscribe Now
                                            </a>
                                        )}
                                    </>
                                ) : (
                                    // When user has some views left
                                    <>
                                        Only {Math.max(0, Number(userPermission) - Number(userViews))} free views left!
                                        ({userViews}/{userPermission} used)
                                        {Number(userViews) > 7 && (
                                            <a href="/subscriptions" className="ms-2 text-primary">
                                                Subscribe Now
                                            </a>
                                        )}
                                    </>
                                )}
                            </p> */}
            </div>

            {/* Bottom nevigation */}
            {mediaQueryVar === false && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0",
                        backgroundColor: "white",
                        width: "100%",
                        zIndex: "100",
                        marginBottom: "0px",
                        marginLeft: "0%",
                    }}
                >
                    <BottomNavigation showLabels>
                        <BottomNavigationAction
                            label="Top Portfolios"
                            onClick={() => navigate("/portfolio-gallery")}
                            icon={
                                <img
                                    src={
                                        loc === "/portfolio-gallery"
                                            ? "/images/dashboardS.svg"
                                            : "/images/dashboardU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="My Portfolios"
                            onClick={() => {
                                navigate(userData ? "/my-portfolio" : "/audit-my-portfolio");
                            }}
                            icon={
                                <img
                                    src={loc === "/my-portfolio" ? "/images/portfolioS.svg" : "/images/portfolioU.svg"}
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="$1/Month Subscription"
                            onClick={() => {
                                if (userData) {
                                    navigate("/subscriptions/screener360");
                                } else {
                                    const originalUrl = "/subscriptions/screener360";
                                    sessionStorage.setItem("originalUrl", originalUrl);
                                    handleLoginClick();
                                }
                            }}
                            icon={
                                <img
                                    src={
                                        loc === "/subscriptions/screener360"
                                            ? "/images/dollarS.svg"
                                            : "/images/dollarU.svg"
                                    }
                                    width={24}
                                    height={24}
                                    alt="Icon"
                                    style={{marginBottom: "-3px"}}
                                />
                            }
                        />
                    </BottomNavigation>
                </div>
            )}
        </div>
    );
};

export default Recommendation;
